import { render, staticRenderFns } from "./layoutProfileMenu.vue?vue&type=template&id=4415bb09&"
import script from "./layoutProfileMenu.vue?vue&type=script&lang=js&"
export * from "./layoutProfileMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tsunagaru-v3-app-mintenant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4415bb09')) {
      api.createRecord('4415bb09', component.options)
    } else {
      api.reload('4415bb09', component.options)
    }
    module.hot.accept("./layoutProfileMenu.vue?vue&type=template&id=4415bb09&", function () {
      api.rerender('4415bb09', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/src/shared/components/layout/layoutProfileMenu.vue"
export default component.exports